<!-- static content data from lang: signup -->
<template>
  <div class="h-100" v-loading="loading">
    <div class="container h-100">
      <div class="row justify-content-center align-items-center h-100">
        <div class="col-lg-5 col-md-7 my-3">
          <div class="brand-logo">
            <!--            <img src="img/brand/logo.jpg" />-->
            <div style="color:white; font-size: 40px;">Smart Visitor</div>
          </div>
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-body px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <h3>{{ lang.label.heading }}</h3>
              </div>
              <Alert :type=type dismissible @removeAlertModal="removeMessage" v-if="alertMessage"> <span
                  class="alert-inner--text">{{ alertMessage }} </span> <button type="button" class="close"
                  data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
              <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                <form role="form" @submit.prevent="handleSubmit(onSubmit(true))">
                  <base-input alternative class="mb-3" name="ID/passport" rules="required"
                    prepend-icon="ni ni-single-02" :placeholder="lang.label.passport + '*'" v-model="model.userName"
                    autocomplete="off"></base-input>
                  <base-input alternative class="mb-3" name="name" rules="required" prepend-icon="fas fa-user-circle"
                    :placeholder="lang.label.name + '*'" v-model="model.name" autocomplete="off"></base-input>
                  <base-input alternative class="mb-3" name="surname" rules="required" prepend-icon="far fa-user-circle"
                    :placeholder="lang.label.surname + '*'" v-model="model.surname" autocomplete="off"></base-input>
                  <base-input alternative class="mb-3" name="email address" rules="email" prepend-icon="ni ni-email-83"
                    :placeholder="lang.label.emailAddress" v-model="model.emailAddress" autocomplete="off"></base-input>
                  <base-input alternative class="mb-3" name="cell phone number"
                    :rules="{ required: true, numeric: true, digits: '10' }" prepend-icon="ni ni-mobile-button"
                    :placeholder="lang.label.phoneNumber + '*'" v-model="model.phoneNumber"
                    @input="copyToWhatsAppNumber" @keypress="isNumber($event)" autocomplete="off"></base-input>
                  <base-input alternative class="mb-3" name="whatsApp number"
                    :rules="{ required: true, numeric: true, digits: '10' }" prepend-icon="fab fa-whatsapp"
                    :placeholder="lang.label.WhatsAppNumber + '*'" @keypress="isNumber($event)"
                    v-model="model.WhatsAppNumber" autocomplete="off"></base-input>
                  <div class="form-group">
                    <base-input :label="lang.label.communicationType" labelClasses="form-control-label asterisk-mark"
                      name="communication type" :rules="{ required: true }">
                      <b-form-group class="mb-0">
                        <b-form-radio-group id="radio-group" v-model="model.communication" autocomplete="off"
                          :options="communicationType" name="radio-options"></b-form-radio-group>
                      </b-form-group>
                    </base-input>
                  </div>
                  <div class="form-group photo-upload">
                    <!-- labelClasses="form-control-label asterisk-mark"
                      name="upload your photo"
                      :rules="{required: true}" -->
                    <base-input :label="lang.label.uploadPhoto" labelClasses="form-control-label asterisk-mark"
                      name="Your photo" :rules="{ required: true }">
                      <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" class="textFile"
                        v-model="model.photo" autocomplete="off" @vdropzone-file-added="filesAdded"
                        @vdropzone-success="fileSuccess" @vdropzone-removed-file="filesRemoved"></vue-dropzone>
                    </base-input>
                  </div>
                  <div class="form-group">
                    <base-input :label="model.allowShareInformation == '1' ? lang.label.allowShareInformation : lang.label.notAllowedShareInformation" name="share information"
                      :rules="{ required: true }">
                      <b-form-group class="mb-0">
                        <b-form-radio-group id="radio-group1" v-model="model.allowShareInformation" autocomplete="off"
                          :options="allowShareInformation" name="radio-options1"></b-form-radio-group>
                      </b-form-group>
                    </base-input>
                  </div>
                  <el-dialog title="Upload Documents" :visible.sync="showPopup" width="30%" :before-close="handleClose">
                    <Alert :type=type dismissible @removeAlertModal="removeMessage" v-if="fileUploadError"> <span
                  class="alert-inner--text">{{ fileUploadError }} </span> <button type="button" class="close"
                  data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
                    <div>
                      <div v-for="(doc, index) in model.documentForms" :key="doc.id" class="document-upload">
                        <el-input placeholder="Enter document name" v-model="doc.name"></el-input>
                        <vue-dropzone ref="fileDropzone" :id="'fileDropzone-' + index" :options="fileUploadOptions"
                          @vdropzone-file-added="onFileAdded(index, $event)"
                          @vdropzone-success="onFileUploadSuccess(index, $event)"
                          @vdropzone-removed-file="onFileRemoved(index, $event)">
                        </vue-dropzone>
                      </div>
                    </div>
                    <span slot="footer" class="dialog-footer">
                      <el-button type="primary" @click="uploadAllDocuments">Upload All</el-button>
                      <el-button type="default" @click="closePopup">Cancel</el-button>
                    </span>
                  </el-dialog>
                  <el-dialog title="Confirmation" :visible.sync="showConfirmation" width="30%"
                    :before-close="closeConfirmation">
                    <p>Do you want to upload the documents now or later?</p>
                    <span slot="footer" class="dialog-footer">
                      <el-button type="primary" @click="uploadNow">Upload Now</el-button>
                      <el-button type="default" @click="uploadLater">Upload Later</el-button>
                    </span>
                  </el-dialog>
                  <div class="text-center">
                    <base-button type="primary" native-type="submit" :disabled="uploading" class="mt-3">{{
                      lang.label.buttons.signUp }}</base-button>
                  </div>
                </form>
              </validation-observer>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12 text-center">
              <span>
                <small>
                  {{ lang.label.alreadyAccount }}
                  <router-link to="/login" class="text-light">{{ lang.label.login }}</router-link>
                </small>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import Alert from "@/components/BaseAlert.vue";
import { Dialog, Button, Message, Upload } from 'element-ui';
import { fetchDocuments } from "../../store/actions";


export default {
  components: {
    vueDropzone: vue2Dropzone,
    Alert,
    'el-dialog': Dialog,
    'el-button': Button,
    'el-upload': Upload,
  },
  data() {
    return {
      showPopup: false,
      showConfirmation: false,
      uploading: false,
      lang: this.$lang.signup,
      alertMessage: '',
      fileUploadError: '',
      loading: false,
      model: {
        userName: "",
        name: "",
        surname: "",
        emailAddress: "",
        phoneNumber: "",
        WhatsAppNumber: "",
        communication: [],
        allowShareInformation: '1',
        photo: "",
        documentForms: null,
      },
      fileUploadOptions: {
        url: "https://httpbin.org/post",
        maxFilesize: 5,
        acceptedFiles: ".pdf,.doc,.docx,.png,.jpg,.jpeg",
        dictDefaultMessage: "Drag files here or click to upload",
        dictFileTooBig: "File is too large ({{filesize}}MB). Max filesize: {{maxFilesize}}MB.",
        dictInvalidFileType: "You can't upload files of this type.",
        autoProcessQueue: false,
        thumbnailWidth: 200,
        addRemoveLinks: false,
        uploadMultiple: false,
        capture: "image/*",
        previewTemplate: this.getTemplate()
      },
      communicationType: [
        { text: "Email", value: "1" },
        { text: "SMS", value: "2" },
        // { text: "WhatsApp", value: "third" }
      ],
      allowShareInformation: [
        { text: "Yes", value: "1" },
        { text: "No", value: "0" },
      ],
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 200,
        addRemoveLinks: true,
        uploadMultiple: false,
        maxFilesize: 10,
        maxFiles: 1,
        acceptedFiles: ".jpg, .jpeg, .png",
        dictDefaultMessage:
          "<div class='upload-docs'><p>Drop file here <br/>or <br/>click to upload</p></div>"
      }
    };
  },
  mounted() {
    this.$store.dispatch('fetchDocuments').then(response => {
      this.model.documentForms = response.data;
    });
  },
  methods: {
    uploadNow() {
      this.showConfirmation = false;
      this.showPopup = true;
    },
    uploadLater() {
      this.showConfirmation = false;
      this.showPopup = false;
      this.onSubmit(false);
    },
    closeConfirmation() {
      this.showConfirmation = false;
    },
    getTemplate() {
      window.handleOpenFileInNewTab = this.handleViewURL

      return `
        <div class="upload-doc" data-file-url="" onclick="window.handleOpenFileInNewTab(this.dataset.fileUrl)">
          Click to preview
        </div>
      `;
    },
    handleViewURL(fileUrl) {
      fetch(fileUrl)
        .then(response => response.blob())
        .then(blob => {
          const objectURL = URL.createObjectURL(blob);
          window.open(objectURL, "_blank");
        })
        .catch(err => console.error('Error fetching the file:', err));
    },
    handleClose() {
      this.showPopup = false;
    },
    async onFileAdded(index, file) {
      if(file.name.length > 100){
        this.fileUploadError = 'File name is too long';
        this.type = 'warning';
        this.$refs.fileDropzone[index].dropzone.removeFile(file);
        this.model.documentForms[index].file = null;
        return;
      }
      this.model.documentForms[index].file = file;
      const previewElement = file.previewElement;
      const base64String = await this.fileToBase64(file);
      previewElement.setAttribute('data-file-url', base64String);
      const dropzone = this.$refs.fileDropzone[index];
      if (dropzone.dropzone.files.length > 1) {
        dropzone.dropzone.removeFile(dropzone.dropzone.files[0]);
      }
    },
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
      });
    },
    onFileUploadSuccess(index, response) {
      this.model.documentForms[index].file = this.$refs.fileDropzone[index].dropzone.files;
      this.uploading = true;
      console.log(`Upload success for document ${index}:`, response);
    },
    onFileRemoved(index, file) {
      this.model.documentForms[index].file = null;
      console.log(`File removed for document ${index}:`, file);
    },
    uploadAllDocuments() {
      this.showPopup = false;
      this.showConfirmation = false;
      this.onSubmit(false);
    },
    closePopup() {
      this.showPopup = false; // Close the main dialog
    },
    isNumber: function (index, evt, flag = false) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      }
    },
    copyToWhatsAppNumber() {
      this.model.WhatsAppNumber = this.model.phoneNumber;
    },
    removeMessage() {
      let self = this;
      let timer = setTimeout(function () {
        if (self.loading == false) {
          self.alertMessage = "";
          clearTimeout(timer)
        }
      }, 3000)
    },
    fileSuccess: function (file) {
      this.uploading = false;
    },
    filesRemoved: function (file, error) {
      this.uploading = false;
    },
    filesAdded() {
      this.model.photo = this.$refs.myVueDropzone.dropzone.files;
      if(this.model.photo[0].name.length > 100){
        this.alertMessage = 'File name is too long';
        this.type = 'warning';
        this.$refs.myVueDropzone.dropzone.removeFile(this.model.photo[0]);
        this.model.photo = null;
        return;
      }
      this.uploading = true;
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    async onSubmit(showConfirmation) {
      // Check if user hasn't agreed to share information
      if (this.model.allowShareInformation === '0') {
        this.alertMessage = "You must agree to the terms and conditions to continue.";
        this.type = "danger";
        return;
      }

      if (showConfirmation) {
        try {
          const isValid = await this.$refs.formValidator.validate();
          if (isValid) {
            this.showConfirmation = showConfirmation;
          } else {
            this.alertMessage = "Please fix validation errors.";
            this.type = "danger";
          }
        } catch (error) {
          this.alertMessage = "Error in validation.";
          console.log('error: ', error);
        }
        return;
      }

      this.loading = true;
      let formData = new FormData();
      formData.append('Username', this.model.userName);
      formData.append('Name', this.model.name);
      formData.append('Surname', this.model.surname);
      formData.append('EmailAddress', this.model.emailAddress);
      formData.append('CellphoneNumber', this.model.phoneNumber);
      formData.append('WhatsAppNumber', this.model.WhatsAppNumber);
      formData.append('Type', 1);
      formData.append('CommsPrefType', this.model.communication);
      formData.append('AllowShareInformation', this.model.allowShareInformation);
      if (this.$refs.myVueDropzone) {
        let imageFiles = this.$refs.myVueDropzone.dropzone.files;
        imageFiles.forEach((object, index) => {
          formData.append('Photograph', object);
        });
      }
      if (!showConfirmation) {
        this.model.documentForms.forEach((doc, index) => {
          if (doc.file) {
            formData.append(`documents[${index}]document_type`, doc.id);
            formData.append(`documents[${index}]document`, doc.file);
          }
        });
      }
      this.$store.dispatch('signUp', formData).then(response => {
        this.loading = false;
        if (response.status == 200) {
          this.alertMessage = response.data.message;
          this.type = "primary";
          this.$router.push({ name: "Login" });
        } else {
          if (typeof response.data.message != 'object') {
            this.alertMessage = response.data.message;
          } else {
            var array = new Array();
            for (let key of Object.keys(response.data.message)) {
              let obj = response.data.message[key][0].includes('field') ? (key + "- " + response.data.message[key][0]) : response.data.message[key];
              array.push(obj)
            } this.alertMessage = array.join(', ');
          }
          this.type = "danger";
        }
      });

    }
  }
};
</script>
<style>
.vue-dropzone .dz-error-message {
  display: none;
  /* Temporarily hide error messages */
}

.dz-progress {
  display: none;
}
</style>